import { useEffect, useState } from 'react';
import { accountMembersQuery, subscribe } from '@/lib/firestore';
import type { Member } from '@/schemas';

export type MemberWithId = Member & { id: string };

export function useMembers(aid: string | null): {
  members: MemberWithId[];
  loading: boolean;
} {
  // Derived loading: see useMyMemberships for the why.
  const [state, setState] = useState<{ loadedAid: string | null; data: MemberWithId[] }>({
    loadedAid: null,
    data: [],
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: [] });
      return;
    }
    setState({ loadedAid: null, data: [] });
    const unsub = subscribe<Member>(accountMembersQuery(aid), (rows) => {
      setState({ loadedAid: aid, data: rows });
    });
    return unsub;
  }, [aid]);
  return {
    members: state.loadedAid === aid ? state.data : [],
    loading: aid != null && state.loadedAid !== aid,
  };
}
